module.exports = __webpack_public_path__ + "img/model_x_black.36a207ce.png";